import { useEffect, useState } from "react";
import { infoUser_request } from "../services/perfil_services";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { infoUser } from "../redux/userSlice";
import { showSnackbar } from "../redux/snackbarSlice";
import { Col, ConfigProvider, Row, Spin } from "antd";
import "./styles/welcomePage.scss";
import imageDoctor from "../Img/welcomepage/doctor-image.webp"

export default function WelcomePage() {
    const dispatch = useDispatch();
    //navegacion
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);

    async function getInfoUser() {
        setLoader(true);
        let response = await infoUser_request();
        if (response["ok"]) {
            dispatch(infoUser(response.data));
            let info = response.data.Usuario;
            sessionStorage.setItem("infoUser", JSON.stringify(info));
            localStorage.setItem("tipoUsuario", response.data.Usuario.Tipo);
            localStorage.setItem("loginAsistente", "0");
            setTimeout(() => {
                navigate("/", {
                    replace: true,
                    state: {
                        logged: true
                    },
                });
            }, 5000);

        } else {
            if (response.status === 404) {
                localStorage.removeItem("token");
                localStorage.removeItem("tipoUsuario");
                sessionStorage.removeItem("infoUser");
                navigate('/login', { replace: true });
            } else {
                dispatch(showSnackbar({
                    show: true,
                    text: response.mensaje,
                    type: "error",
                }));
            }
        }
        setLoader(true);
        return;
    }

    useEffect(() => {
        // TODO Cambiar rastreador cuando se muestre de nuevo la pagina de pagar licencia

        // Ejecutar evento de conversión
        // window.gtag("event", "conversion", {
        //     send_to: "AW-17156846047/IhuSCJ6G0tMaEN_jgvU_",
        //     value: 1.0, // puedes hacerlo dinámico
        //     currency: "MXN",
        // });
        getInfoUser();
    }, [])

    return (

        <Row className="welcomePage-container" style={{ justifyContent: 'center', alignContent: "center", display: "block" }}>
            <Row className="flex-welcomePage">
                <div className="welcomePage-container">
                    <div className="header-container"></div>
                    <Row style={{ justifyContent: "center" }}>
                        <Col className="col-description">
                            <h1 style={{ color: "#3B7DB2", fontWeight: "normal", textAlign: "center" }}>¡Bienvenido a</h1>
                            <Row style={{ justifyContent: "center" }}>
                                <h1 style={{ color: "#3B7DB2", fontSize: "28px", textAlign: "center" }}>YGIA</h1>
                                <h1 style={{ color: "#3B7DB2", fontWeight: "normal", textAlign: "center" }}>!</h1>
                            </Row>
                            <h3 style={{ textAlign: "center" }}>Digitalizar tu consultorio nunca fue tan fácil.</h3>
                        </Col>
                        <Col sm={{ flex: "60%" }} style={{ textAlign: "center", height: "30dvh" }}>
                            <img style={{ width: "50dvh" }} src={imageDoctor} />
                        </Col>
                    </Row>
                </div >
            </Row >
            <br />
            <br />
            <Row style={{ justifyContent: "center" }}>
                <ConfigProvider
                    theme={{
                        token: {
                            colorPrimary: "white"
                        }
                    }}
                >
                    <Spin size="large" spinning={loader} />
                </ConfigProvider>
            </Row>
            <br />
            <h3 style={{ color: "white", textAlign: "center" }}>Preparando sesión</h3>

        </Row>
    );
}